import { SCHEDULE_TASK_TYPE } from "../types";
import { useScheduleTask } from "./hooks";
import ScheduleDate from "./ScheduleDate";
import ScheduleTime from "./ScheduleTime";
import { ScheduleTaskProps } from "./types";

const ScheduleTask = ({
    type,
    isLoading,
    scheduleDate,
    scheduleTime
}: ScheduleTaskProps) => {
    return type === SCHEDULE_TASK_TYPE.ByDate ? (
        <ScheduleDate isLoading={isLoading} {...scheduleDate} />
    ) : (
        <ScheduleTime isLoading={isLoading} {...scheduleTime} />
    );
};

export default ScheduleTask;
export { useScheduleTask };
